var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-pb-3"},[_c('input-switch',{on:{"change":_vm.showSpeakersChanged},model:{value:(_vm.show_speakers),callback:function ($$v) {_vm.show_speakers=$$v},expression:"show_speakers"}}),_vm._v(" "),_c('label',[_vm._v("Show Speakers")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d5ccf77","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/speakers/SpeakersToggle.vue
// module id = null
// module chunks = 